import { isDemoUser } from "@/utils/userFlags";

const coerceString = (value) => {
  if (value === undefined || value === null) return "";
  return String(value);
};

const getCityCountry = (user) => {
  const metadata = user?.metadata || {};
  const city =
    metadata?.city ||
    metadata?.location?.city ||
    metadata?.address?.city ||
    "";
  const country =
    metadata?.country ||
    metadata?.location?.country ||
    metadata?.address?.country ||
    "";

  return { city: coerceString(city), country: coerceString(country) };
};

const getSchoolId = (user) => {
  // Handle user.school (could be string, ObjectId, or object)
  if (user?.school) {
    // If it's an object with _id, extract the _id
    if (typeof user.school === "object" && user.school !== null) {
      const id = user.school._id || user.school.toString();
      return coerceString(id);
    }
    return coerceString(user.school);
  }
  
  // Handle user.schools array (could contain strings, ObjectIds, or objects)
  if (Array.isArray(user?.schools) && user.schools.length > 0) {
    const firstSchool = user.schools[0];
    // If it's an object with _id, extract the _id
    if (typeof firstSchool === "object" && firstSchool !== null) {
      const id = firstSchool._id || firstSchool.toString();
      return coerceString(id);
    }
    return coerceString(firstSchool);
  }
  
  return "";
};

const getDistrictId = (user) => {
  // Handle user.district (could be string, ObjectId, or object)
  if (user?.district) {
    // If it's an object with _id, extract the _id
    if (typeof user.district === "object" && user.district !== null) {
      const id = user.district._id || user.district.toString();
      return coerceString(id);
    }
    return coerceString(user.district);
  }
  
  // Handle user.districts array (could contain strings, ObjectIds, or objects)
  if (Array.isArray(user?.districts) && user.districts.length > 0) {
    const firstDistrict = user.districts[0];
    // If it's an object with _id, extract the _id
    if (typeof firstDistrict === "object" && firstDistrict !== null) {
      const id = firstDistrict._id || firstDistrict.toString();
      return coerceString(id);
    }
    return coerceString(firstDistrict);
  }
  
  return "";
};

export const getSafeUserContext = (user) => {
  if (!user) return {};
  const { city, country } = getCityCountry(user);
  const timezone =
    Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  const locale = navigator?.language || "";
  const schoolId = getSchoolId(user);
  const districtId = getDistrictId(user);

  return {
    role: user?.role || "",
    is_demo: isDemoUser(user),
    city,
    country,
    school_id: schoolId,
    district_id: districtId,
    timezone: coerceString(timezone),
    locale: coerceString(locale),
  };
};
